import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonContent, IonHeader, IonTitle, IonRefresher, RefresherEventDetail, IonRefresherContent, NavController, LoadingController } from '@ionic/angular/standalone';
import { IonRefresherCustomEvent } from '@ionic/core';
import { StateService } from 'src/app/services/state.service';
import { SimpleButtonComponent } from "../../components/primitives/simple-button/simple-button.component";
import { addIcons } from 'ionicons';
import { addOutline, syncOutline } from 'ionicons/icons';
import { AddScriptCardComponent } from "./add-script-card/add-script-card.component";
import { ScriptCardComponent } from "./script-card/script-card.component";
import { CustomerScript } from '@chemist2u/types-client/C2U/ParseObjects/CustomerScript';
import { NavigationEnd, Router } from '@angular/router';
import { ButtonComponent } from "../../components/primitives/button/button.component";
import { AmplitudeService } from 'src/app/services/amplitude.service';
import { NativeService } from 'src/app/services/native.service';

@Component({
    selector: 'app-script-wallet',
    templateUrl: './script-wallet.page.html',
    styleUrls: ['./script-wallet.page.scss'],
    imports: [IonContent, IonHeader, IonTitle, CommonModule, IonRefresher, IonRefresherContent, SimpleButtonComponent, AddScriptCardComponent, ScriptCardComponent, ButtonComponent]
})
export class ScriptWalletPage implements OnInit {
  private $state = inject(StateService);
  private $amplitude = inject(AmplitudeService);
  private router = inject(Router);
  private navCtrl = inject(NavController);
  private loadCtrl = inject(LoadingController);

  public isLoggedIn = this.$state.isLoggedIn;

  public scripts = signal<CustomerScript[]>([]);

  constructor() {
    addIcons({ syncOutline, addOutline });
  }

  ngOnInit(): void {
    this.$state.bAuthAppReady.subscribe(() => {
      this.refreshScripts(true);
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd && event.url === '/tabs/my-scripts') {
          this.refreshScripts(true);
        }
      });
    });
  }

  async doRefresh(event: IonRefresherCustomEvent<RefresherEventDetail>) {
    this.refreshScripts();
    event.target.complete();
  }

  async refreshScripts(silentLoad = false) {
    const loader = await this.loadCtrl.create();
    try {
      if (!silentLoad) await loader.present();
      const scripts = await CustomerScript.Query().equalTo('customer', this.$state.bUser.getValue()!).find();
      this.scripts.set(scripts);
      this.$amplitude.track(scripts.length > 0 ? 'MY_SCRIPTS_VIEWED' : 'MY_SCRIPTS_EMPTY_VIEWED', {
        origin: "MyScripts",
        content: "My Scripts",
        UI: "MyScripts_Screen",
      });
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      if (!silentLoad) await loader.dismiss();
    }
  }
  
  addScript(fromPlus = false) {
    this.navCtrl.navigateForward(['/add-script']);
    this.$amplitude.track('ADD_SCRIPT_CTA', {
      origin: "MyScripts",
      content: this.scripts().length > 0 ? "My Scripts" : "Empty State",
      UI: fromPlus ? "Plus_Icon" : "PrimaryCTA_Button",
    });
  }
}